import { FormControlLabel, styled } from '@material-ui/core';
import { Input, TextInput } from '@room-match/shared-ui-components';

export const MainContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  gap: 10,

  '& > div > div:not(:first-child)': {
    marginTop: 5,
  },
});

export const FlexContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const CustomFormControl = styled(FormControlLabel)({
  margin: '0 -7px 0 5px',
});

export const FlexTwoColumn = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
});

export const DiscountContainer = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  position: 'relative',
  margin: '20px 0',

  '&::after': {
    content: '""',
    background: '#2e3c50',
    height: '1px',
    position: 'absolute',
    width: '110%',
    bottom: '-10px',
    left: '-5%',
  },

  '&::before': {
    content: '""',
    background: '#2e3c50',
    height: '1px',
    position: 'absolute',
    width: '110%',
    top: '-10px',
    left: '-5%',
  },
});

export const CustomTextInput = styled(Input)({
  height: 39,
  width: 135,
  marginBottom: 5,

  '& .MuiInputBase-root': {
    borderRadius: '5px !important',
  },

  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#364459 !important',
  },

  '& input': {
    padding: '5px 10px',

    '&::placeholder': {
      color: '#516481',
    },
  },
});
